import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const PaymentCancel = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'rgba(30,41,59,0.8)',
        backdropFilter: 'blur(20px)',
        borderRadius: '24px',
        border: '1px solid rgba(255,255,255,0.1)',
        padding: '60px',
        textAlign: 'center',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          background: 'rgba(251,191,36,0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <XCircle size={40} style={{ color: '#fbbf24' }} />
        </div>
        
        <h2 style={{ color: 'white', fontSize: '28px', marginBottom: '12px' }}>
          Payment Cancelled
        </h2>
        
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '16px', marginBottom: '32px', lineHeight: 1.6 }}>
          Your payment was cancelled. No charges were made to your account. You can try again whenever you're ready.
        </p>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Link
            to="/books/cire-interactive"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              padding: '16px 32px',
              background: 'linear-gradient(135deg, #D4AF37 0%, #B8860B 100%)',
              borderRadius: '12px',
              color: '#1e293b',
              fontWeight: '700',
              fontSize: '16px',
              textDecoration: 'none',
              boxShadow: '0 4px 20px rgba(212,175,55,0.3)'
            }}
          >
            <RefreshCw size={18} />
            Try Again
          </Link>
          
          <Link
            to="/books"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              color: 'rgba(255,255,255,0.6)',
              textDecoration: 'none',
              fontSize: '14px'
            }}
          >
            <ArrowLeft size={16} />
            Browse Other Books
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
